export const fontFamilyPrimary = `'Noto Sans', sans-serif`;
export const fontFamilySecondary = `'Raleway', sans-serif`;
export const fontFamilyMulti = `'Multi', sans-serif`;
